(function () {
  function markAdded(wrapper) {
    const btn = wrapper.querySelector('.cartx-add-to-cart:not(.plus)');
    if (!btn) return;
    wrapper.classList.add('cartx-is-added');
    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent.trim();
    if (btn.dataset.originalText) btn.textContent = 'Added to Cart';
    clearTimeout(wrapper._addedTimer);
    wrapper._addedTimer = setTimeout(function () {
      wrapper.classList.remove('cartx-is-added');
      btn.textContent = btn.dataset.originalText;
    }, 2500);
  }

  function initAddedToCart() {
    document.querySelectorAll('.am-pm-routine-builder .cartx-product-button-wrap').forEach(function (wrapper) {
      let wasLoading = false;
      new MutationObserver(function () {
        const loading = wrapper.classList.contains('cartx-button-loadding');
        if (loading) { wasLoading = true; }
        else if (wasLoading) { wasLoading = false; markAdded(wrapper); }
      }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function initBundleCta() {
    document.querySelectorAll('.am-pm-routine-builder__bundle-cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variant = btn.closest(
          '.am-pm-routine-builder__variant--am, .am-pm-routine-builder__variant--pm'
        );
        if (!variant) return;

        var variantObject = {};
        variant
          .querySelectorAll('.cartx-product-button-wrap[data-variant-id]')
          .forEach(function (wrap) {
            var id = wrap.getAttribute('data-variant-id');
            var price = wrap.getAttribute('data-price');
            var type = wrap.getAttribute('data-product-type') || '';
            if (id) {
              variantObject[id] = {
                quantity: 1,
                price: parseInt(price, 10) || 0,
                type: type,
              };
            }
          });

        if (Object.keys(variantObject).length > 0 && typeof cartx === 'function') {
          cartx(variantObject, 'ADD');
          setTimeout(function () {
            var cartDrawer = document.querySelector('cart-drawer');
            var overlay = document.querySelector('.cartx-drawer-overlay');
            if (cartDrawer && overlay) {
              cartDrawer.classList.add('drawer-open');
              overlay.classList.add('open-overlay');
            }
            document.body.classList.add('cartx-open');
          }, 300);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBundleCta();
      initAddedToCart();
    });
  } else {
    initBundleCta();
    initAddedToCart();
  }
})();
